<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    @ok="handleOk"
    @cancel="cancel"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-form-model-item label="名称" prop="descript"
        ><a-input v-model="formData.descript" :maxLength="20"
      /></a-form-model-item>
      <a-form-model-item label="代码" prop="templateCode">
        <a-input
          v-model="formData.templateCode"
          :maxLength="20"
          :disabled="modal.type == 'add' ? false : true"
        />
      </a-form-model-item>
      <a-form-model-item label="类型" prop="type">
        <a-select v-model="formData.type" placeholder="请选择" allowClear>
          <a-select-option value="SMS">短信</a-select-option>
          <a-select-option value="EMAIL">邮件</a-select-option>
          <a-select-option value="WECHAT">微信</a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item label="接收人" prop="receive"
        ><a-input v-model="formData.receive"
      /></a-form-model-item>

      <a-form-model-item
        label="邮件主题"
        v-if="formData.type == 'EMAIL'"
        prop="subject"
        ><a-input v-model="formData.subject"
      /></a-form-model-item>

      <a-form-model-item label="模板内容" prop="content"
        ><a-input v-model="formData.content" type="textarea"
      /></a-form-model-item>
      <a-form-model-item label="发送过期限制" prop="timelimit">
        <a-input-number
          v-model="formData.timelimit"
          :min="0"
          :step="0.1"
          :max="10"
        />
        小时
      </a-form-model-item>

      <a-form-model-item
        label="短信关联代码"
        v-if="this.formData.type == 'SMS'"
        prop="smsSignCode"
        ><a-input v-model="formData.smsSignCode"
      /></a-form-model-item>

      <a-form-model-item
        label="微信模板ID"
        v-if="this.formData.type == 'WECHAT'"
        prop="weixinTemplateId"
        ><a-input v-model="formData.weixinTemplateId"
      /></a-form-model-item>

      <a-form-model-item label="排序" prop="listOrder"
        ><a-input-number v-model="formData.listOrder" :min="1" :max="99999"
      /></a-form-model-item>

      <a-row>
        <a-col :span="12">
          <a-form-model-item
            label="是否停用"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isHalt == 'T' ? true : false"
              @change="onChange('isHalt')"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: "TemplateInfo",
  data() {
    // handler
    let handleWeixin = (rule, value, callback) => {
      if (this.formData.type == "WECHAT") {
        if (!value) {
          callback("请输入微信模板ID");
        }
      }
      callback();
    };
    // handler
    let handleSms = (rule, value, callback) => {
      if (this.formData.type == "SMS") {
        if (!value) {
          callback("请输入短信关联代码");
        }
      }
      callback();
    };
    // handler
    let handleSubject = (rule, value, callback) => {
      if (this.formData.type == "EMAIL") {
        if (!value) {
          callback("请输入邮件主题");
        }
      }
      callback();
    };
    return {
      confirmLoading: false,
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        templateCode: "",
        descript: "",
        type: "",
        receive: "",
        subject: "",
        content: "",
        timelimit: 0,
        isHalt: "F",
        listOrder: 1,
        smsSignCode: "",
        weixinTemplateId: ""
      },
      //form rules
      rules: {
        templateCode: [
          {
            required: true,
            message: "请输入代码",
            trigger: "change"
          }
        ],
        descript: [
          {
            required: true,
            message: "请输入名称",
            trigger: "change"
          }
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change"
          }
        ],
        receive: [
          {
            required: true,
            message: "请输入接收人",
            trigger: "change"
          }
        ],
        subject: [{ validator: handleSubject }],
        content: [
          {
            required: true,
            message: "请输入模板内容",
            trigger: "change"
          }
        ],
        smsSignCode: [{ validator: handleSms }],
        weixinTemplateId: [{ validator: handleWeixin }]
      }
    };
  },
  created() {},
  methods: {
    showModal(type, data) {
      this.modal.visible = true;
      this.modal.title = type == "add" ? "添加模板" : "编辑模板";
      this.modal.type = type;
      if (data && type == "edit") {
        this.formData = Object.assign({}, data);
      }
    },
    onChange(column) {
      if (this.formData[column] == "T") {
        this.formData[column] = "F";
      } else {
        this.formData[column] = "T";
      }
    },
    cancel() {
      this.formData = {
        templateCode: "",
        descript: "",
        type: "",
        receive: "",
        subject: "",
        content: "",
        timelimit: 0,
        isHalt: "F",
        listOrder: 1,
        smsSignCode: "",
        weixinTemplateId: ""
      };
      this.confirmLoading = false;
      this.$refs.ruleForm.resetFields();
      this.modal.visible = false;
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          this.confirmLoading = true;
          let action = "saveEdmTemplate";
          if (this.modal.type == "edit") {
            action = "modifyEdmTemplate";
          }
          this.$http.systemBksApi[action](param)
            .then(res => {
              if (res.result == 0) {
                this.cancel();
                this.$emit("success");
                this.$message.success(res.msg);
              }
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style></style>
